import React from 'react';

import { useJobDescriptionsFromExternalWebsitesState, useJobDescriptionsFromExternalWebsitesActions } from './JobDescriptionsFromExternalWebsitesContext';
import { archiveJobDescriptionFromExternalWebsite } from './restApi';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const ArchiveJobDescriptionFromExternalWebsiteModal = () => {
  const state = useJobDescriptionsFromExternalWebsitesState();
  const { closeArchiveJobDescriptionFromExternalWebsiteModal, onResponse, onError } = useJobDescriptionsFromExternalWebsitesActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");

  const handleSubmit = () => {
    archiveJobDescriptionFromExternalWebsite({
      onResponse,
      onError,
      body: {
        authenticityToken,
        jobDescriptionFromExternalWebsiteId: state?.archiveJobDescriptionFromExternalWebsite?.jobDescriptionFromExternalWebsiteId,
      },
    });
  };

  return (
    <StandardModal
      isOpen={state?.archiveJobDescriptionFromExternalWebsiteModalIsOpen}
      contentLabel="Archive Job Description"
      onRequestClose={closeArchiveJobDescriptionFromExternalWebsiteModal}
    >
      <Form onSubmit={handleSubmit}>
        <FormInstruction>
          <strong>Are you sure you want to archive this job description?</strong>
          <br />
          <br />
          This action is not reversible. Once archived, the job description will be permanently removed from active listings and cannot be restored.
        </FormInstruction>

        <ResponsiveContainer name="form-actions">
          <FormActions>
            <Button
              variant="secondary"
              onClick={closeArchiveJobDescriptionFromExternalWebsiteModal}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="destructive"
            >
              Archive Job Description
            </Button>
          </FormActions>
        </ResponsiveContainer>
      </Form>
    </StandardModal>
  );
};

export default ArchiveJobDescriptionFromExternalWebsiteModal;